<template>
	<div id="appbox">
		<div class="top">
			<img src="../../../static/img/jylogo.png" alt="" style="position: absolute;top: 32px;left: 40px;width: 225px;height: 80px;object-fit: contain;" @click="gohome">
			<div class="nav" style="font-size: 24px;font-family: 'Courier New', Courier, monospace;text-shadow: 2px 2px 4px rgba(46,41,41,.6);">
					<div class="nav_box" @click="gohome" >首页</div>
				<div class="nav_box" @click="gocamp" >基地信息</div>
				<!-- <div class="nav_box" @click="handletags(0)" >基地信息</div> -->
				<div class="nav_box"   v-for="(item,index) in colCate" v-bind:key="index" @click="goCourse(item.id)"  >{{ item.title }}</div>
				
				
			</div> 
		</div>
		<div class="swim_box"  v-if="screenWidth>785">
			<div class="swim_title">
				小程序查看
			</div>
			<div class="swim_code">
				<img :src="coursedata.sun_code" alt="" srcset="">
			</div>
		</div>
		<div class="bgimg">
			<div class="main_box" :style="screenWidth>785?'':'width:100%;'">
			<div class="acttop_box" :style="screenWidth>785?'':'width:100%; flex-direction: column;'">
					<div class="acttop_imgs" :style="screenWidth>375?'':'padding:10px 0px;'">
						    <el-carousel :height="screenWidth>375?'210px':(screenWidth*210/375)+'px'">
						      <el-carousel-item >
						        <h3 class="small"  style="height: 100%;"><img :src="coursedata.cover" style="width: 100%;height: 100%;object-fit: cover" alt="" srcset=""></h3>
						      </el-carousel-item>
						    </el-carousel>
					</div>
					<div class="acttop_msg" :style="screenWidth>785?'':'width:calc(100% - 40px);padding:10px;'">
						<el-descriptions class="margin-top" :title="coursedata.title" :column="1"  >
						    <el-descriptions-item   >
						      <template slot="label">
						        <!-- <i class="el-icon-user"></i> -->
						        产品编码
						      </template>
						      {{coursedata.product_number}}
						    </el-descriptions-item>
						    <el-descriptions-item >
						      <template slot="label">
						        <!-- <i class="el-icon-mobile-phone"></i> -->
						        出行方式
						      </template>
						      {{coursedata.back_transport}}
						    </el-descriptions-item>
							 <el-descriptions-item >
						      <template slot="label">
						        <!-- <i class="el-icon-mobile-phone"></i> -->
						        价格
						      </template>
						      ￥{{coursedata.price}}
						    </el-descriptions-item>
					 		<el-descriptions-item >
						      <template slot="label">
						        <!-- <i class="el-icon-mobile-phone"></i> -->
						        类型
						      </template>
						      {{coursedata.category}}-{{ coursedata.attr}}-{{ coursedata.area_type}}
						    </el-descriptions-item>
							<el-descriptions-item >
							  <template slot="label">
							    标签
							  </template>
							 <el-tag size="small" v-for="category in coursedata.tags" :key="category" color="#FE7C2B" effect="dark" >{{category}}</el-tag>
							</el-descriptions-item>
							
						</el-descriptions>
					</div>
				</div>
				<div class="camp_item" :style="screenWidth>785?'':'width:calc(100% - 30px);padding:15px;'"  @click="gocampdetail(coursedata.supplier_id)">
					<div class="moduletitle" :style="screenWidth>785?'':'font-size:18px;'">
						<span class="actblock" :style="screenWidth>785?'':'height:30px;'" ></span>基地信息
					</div>
					<div class="campmsg_box" :style="screenWidth>785?'':'width:100%;flex-direction: column;'" >
						<div class="camp_img" :style="screenWidth>785?'':'width:100%;aspect-ratio: 337/161;height:auto;margin:0px;'" >
							<img :src="coursedata.supplier_cover" alt="" srcset="">
						</div>
						<div class="camp_msg"  :style="screenWidth>785?'':'width:100%;'" >
							<div class="camp_title">
								{{coursedata.supplier}}
							</div>
							<div class="camp_phone">
								<i class="el-icon-phone-outline" ></i>
								{{coursedata.supplier_mobile ? coursedata.supplier_mobile : '暂无联系方式'}}
							</div>
							<div class="camp_address" @click.stop="gomap({latitude:coursedata.camp.latitude,longitude:coursedata.camp.longitude})"> 
								<i class="el-icon-location-information" ></i>
								{{ coursedata.supplier_address  ? coursedata.supplier_address: "暂无地址"}}
							</div>
						</div>
						
					</div>
					
				</div>
				<div class="coursemain_box" style="margin-bottom: 40px;">
					<el-tabs v-model="activeName" type="card" >
						<el-tab-pane  label="产品说明" >
						<div class="pro_msg">
							{{coursedata.highlights}}
						</div>
							
							
						</el-tab-pane>
						<el-tab-pane  label="行程" >
							  <div class="detail_box">
        <div class="time_title">
          <div class="title_left"  ></div>
          <div>行程安排</div>
        </div>
      <div v-for="item in coursedata.day_set">
        <div class="xc_top">
          <div class="xc_time">
            <div>DAY</div>
            <div>{{item.num}}</div>
          </div>
          <div class="xc_title">{{item.attraction}}</div>
        </div>
        <div class="xc_contain" >
         <div style="min-height: 30px;">
          <img src="https://review-1254115215.cos.ap-beijing.myqcloud.com/20251112/3befa78e0e2d303da75d1b74f862b721.png" class="xc_icon" mode="" /> 
         </div>
         <div style="flex-wrap:wrap;display: flex;">
          <div class="xc_col">
            <div style="min-width: 50px;">早餐：</div>
            <div>
				<i class="el-icon-success" style="color:#FE7C2B" v-if="item.dining.breakfast.flag==1"></i>
				<i class="el-icon-error" style="color:#FE7C2B" v-else></i>
             
            </div>
          </div>
          <div class="xc_col">
            <div style="min-width: 50px;">午餐：</div>
            <div>
            <i class="el-icon-success" style="color:#FE7C2B" v-if="item.dining.breakfast.flag==1"></i>
				<i class="el-icon-error" style="color:#FE7C2B" v-else></i>
             
            </div>
          </div>
          <div class="xc_col">
            <div style="min-width: 50px;">晚餐：</div>
            <div>
              <i class="el-icon-success" style="color:#FE7C2B" v-if="item.dining.breakfast.flag==1"></i>
				<i class="el-icon-error" style="color:#FE7C2B" v-else></i>
            </div>
          </div>
         </div>
        </div>
        <div class="xc_contain">
        <div style="display: flex;min-width: 100px;">
          <img src="https://review-1254115215.cos.ap-beijing.myqcloud.com/20251112/64a1d63342ce65f8822afa27f6151796.png" class="xc_icon"  />
          <div>交通：</div>
        </div>
          <div>{{item.transport||'无'}}</div>
        </div>
        <div class="xc_contain">
        
         <div style="display: flex;min-width: 100px;">
          <img src="https://review-1254115215.cos.ap-beijing.myqcloud.com/20251112/ee425cdf861ffabf4ed038221d9f467d.png" class="xc_icon" mode="" />
          <div>住宿：</div>
         
         </div>
         <div>{{item.lodging||'无'}}</div>
        </div>
        <div class="xc_contain">
        <div style="min-width: 100px;display: flex;">
          <img src="https://review-1254115215.cos.ap-beijing.myqcloud.com/20251112/4d61631c5254f9868d015d70887173d8.png" class="xc_icon" mode="" />
          <div>景点：</div>
        </div>
          <div>{{item.attraction}}</div>
        </div>
        <div class="pro_msg"  style="margin-bottom: 10px;">
          {{item.content}}
		</div>
        <image v-for="child in item.imgs"   bind:tap="predivImage"   :src=child style="width:100%"/>
      </div>
      </div>
							
							
						</el-tab-pane>
						<el-tab-pane  label="须知" >
							   <div class="detail_box">
        <div class="time_title">
          <div class="title_left" ></div>
          <div>预定须知</div>
        </div>
        <div class="xz_title_box">
          <div class="xz_title">费用包含</div>
         
        </div>
        <div class="pro_msg">{{coursedata.cost_include|| '暂无信息'}}</div>
     
      <div>
        <div class="xz_title_box">
          <div class="xz_title">费用不包含</div>
          
        </div>
        <div class="pro_msg">{{coursedata.cost_exclude|| '暂无信息'}}</div>
      </div>
      <div>
        <div class="xz_title_box">
          <div class="xz_title">预定须知</div>
          
        </div>
        <div class="pro_msg">{{coursedata.remind|| '暂无信息'}}</div>
      </div>
      <div>
        <div class="xz_title_box">
          <div class="xz_title">退改规则</div>
         
        </div>
        <div class="pro_msg">{{coursedata.return_info|| '暂无信息'}}</div>
      </div>
      <div>
        <div class="xz_title_box">
          <div class="xz_title">温馨提示</div>
          
        </div>
        <div class="pro_msg">{{coursedata.notice|| '暂无信息'}}</div>
      </div>
      <div>
        <div class="xz_title_box">
          <div class="xz_title">保险信息</div>
        
        </div>
        <div class="pro_msg">{{coursedata.insurance_info|| '暂无信息'}}</div>
      </div>
        <div class="xz_title_box">
          <div class="xz_title">导师证件</div>
        
        </div>
        <div>{{coursedata.mentor_id.content|| '暂无信息'}}</div>
        <div class="teacher_box">
          <!-- <div class="teacher_box_detail" bind:tap="previewImage" wx:for="{{data.mentor_id.file}}" data-imgs="{{data.mentor_id.file}}"  data-src="{{item.file}}">
            <image src="https://review-1254115215.cos.ap-beijing.myqcloud.com/20251112/9ee272c25590adbec99a697102d3a617.png" mode=""/>
            <div>{{item.name}}({{item.category_name}})</div>
          </div> -->
      
        </div>
        <div>
        <div class="xz_title_box">
          <div class="xz_title">应急预案</div>
         
        </div>
        <div class="pro_msg">{{coursedata.emergency_plan}}</div>
      </div>
      <div>
        <div class="xz_title_box">
          <div class="xz_title">其他信息</div>
          
        </div>
        <div class="pro_msg">{{coursedata.other_info}}</div>
      </div>
      </div>
							
							
						</el-tab-pane>
					  </el-tabs>
				</div>
		</div>
		</div>
<!-- 		<div class="swim_box">
			<div class="swim_title">
				小程序查看
			</div>
			<div class="swim_code">
				<img :src="coursedata.sun_code" alt="" srcset="">
			</div>
		</div> -->
		<!-- <div :class="tops?'navbar':'navbar-top'"  v-if="screenWidth>785">
		     <el-tooltip class="item" effect="dark" content="返回首页" placement="left">
		             <a style="display: flex;flex-direction: column;justify-content: center; align-items: center;"  @click="gohome()"><i class="el-icon-s-home"></i>
								<div style="font-size: 14px;">首页</div></a>
		     </el-tooltip>
		     <div  class="qrShow3 right2"   v-if="showofficialQR">
					<img src="../../../static/img/gzhsuncode.jpg" style="width: 100px; height: 100px;border-radius: 8px;" />
				</div>
				
				<div  class="qrShow2 right2" v-if="showserviceQR">
					<img src="../../../static/img/客服码.png" style="width: 100px; height: 100px;border-radius: 8px;" />
				</div>
				<a style="display: flex;flex-direction: column;justify-content: center; align-items: center;" @mouseover="showserviceQRCode" @mouseleave="hideserviceQRCode"><i class="el-icon-service"></i>  
							
				    <div style="font-size: 14px;">客服</div></a>
		     <div  class="qrShow right" v-if="showQR">
							<img src="../../../static/img/suncode.jpg" style="width: 100px; height: 100px;border-radius: 8px;" />
		     </div>
		    
		     <el-tooltip class="item" effect="dark" content="返回顶部" placement="left" v-if="tops">
		         <a @click="gotop"><i class="el-icon-caret-top"></i>
		         <br>
		         <span>顶部</span></a>
		     </el-tooltip>
		 </div> -->
		<!-- footer -->
		<!-- <div class="pagesbottom_box"  :style="screenWidth>785?'':'width:100%;padding-top:20px;'" >
			
			<div class="row" :style="screenWidth>785?'':'width:calc(100% - 20px);padding:0px 10px;'" >
				<div class="bottom_right"  abort="" style="margin: 0 auto;align-items: center;padding-top: 10px;">
					<div class="bottom_msg">
						<a href="https://beian.miit.gov.cn/" target="_blank" rel="noopener">{{' '+pcsetdata.icp}}</a>
					</div>
					<div class="bottom_msg">
						版权所有：黑龙江省研学实践教育协会 
					</div>
					<div class="bottom_msg">
						指导单位：黑龙江省教育厅 
					</div>
					
				</div>
				
			</div>
		</div> -->
	</div>
</template>

<script>
	import {  getproductlist,getcolCate,getNewslist, getPac, getCourselist, getPc,getbottomnav ,} from '@/request/api'
	
	export default {
	  name: "CourseDetails",
	    // components: {
	    //   navTab
	    // },
	  data(){
		  return {
			colCate:[],
			  bottomnav:[],
			  //搜索相关
				top_search_url:'/Siteall',
				options: [
				{
					value: '/Siteall',
					label: '全站搜索'
				},{
				  value: '/Camplist',
				  label: '营地搜索'
				}, {
				  value: '/Baselist',
				  label: '基地搜索'
				}, {
				  value: '/Courselist',
				  label: '课程搜索'
				},{
				  value: '/Newslist',
				  label: '资讯搜索'
				},
				{
				  value: '/Activitylist',
				  label: '活动搜索'
				},
				{
				  value: '/Linelist',
				  label: '线路搜索'
				},
				{
				  value: '/mentorlist',
				  label: '导师搜索'
				},],
				//搜索相关
				manage_url:'/',
				manageoptions:[
					{
					  value: '/',
					  label: '管理入口'
					}, {
					  value: 'https://yxwy.wanjiaxiao.cn/',
					  label: '机构管理后台'
					},
					 {
						value:'http://xh.wanjiaxiao.cn/seeyon/index.jsp',
						 label: '研学OA平台'
					 }
				],
				activeIndex2: '/CourseDetails',
				phoneboxshow:false,
				userInfo: {
				  username: "",
				  education_name: "",
				  role_level: ""
				},
				logintype:true,
				banner:[
				],
				camptypes:[
					{ text: '全部', value: 0 },
					{ text: '基地', value: 2 },
					{ text: '营地', value: 1 },
				],
				categorytypes:[],
				camptype:0,
				camplist:[],
				quicklist:[],
				aclist:[],
				newsiconon:'',
				category_id:0,
				period:0,
				total:0,
				page_index:1,
				uuid:'',
				coursedata:{},
				activeName:0,
				pcsetdata:{},
				//侧边栏
				 showQR:false,
			 showserviceQR:false,
			  showofficialQR:false,
				tops:false,
				heights:window.innerHeight,
				scrolltop:'',
				//屏幕宽高
				// 屏幕宽度
				screenWidth: window.innerWidth,
				top_bannerWidth:Math.round(window.innerWidth/3.42),
				// 屏幕高度
				screenHeight: window.innerHeight,
				//手机端导航栏
				vannavshow:false,
				vannavlist:[
					{
						link:'/Home',
						text:'研学首页'
					},
					{
						link:'/Camplist',
						text:'营地列表'
					},
					{
						link:'/Newslist',
						text:'资讯资讯'
					},
					{
						link:'/Baselist',
						text:'基地列表'
					},
					{
						link:'/Courselist',
						text:'研学课程'
					},
					{
						link:'/Activitylist',
						text:'研学活动'
					},
					{
						link:'/Linelist',
						text:'研学线路'
					},
					
					{
						link:'/mentorlist',
						text:'研学导师'
					},
					{
						link:'/expertlist',
						text:'专家团队'
					},
				],
		      }
	  },
	  beforeCreate(){
	  	   const loading = this.$loading({
	  	            lock: true,
	  	            text: '页面载入……',
	  	            // spinner: 'el-icon-loading',
	  	            background: '#ffffff'
	  	          });
	  },
	  created() {
		//   this.getpcset()
	  },
	  mounted() {
		   const { id } = this.$route.query;
		    window.addEventListener('resize', this.handleResize, true)
		   this.uuid = id
		   var token = localStorage.getItem('token')||''
		   this.token=token
		    // this.getbottomnav()
			this.getDetails()
			this.getcolCate()
			console.log("到这了");
			// this.gettypes()
			
	 window.addEventListener('scroll', this.scrollToTop)
	 		
	 },
	  destroyed () {
	         window.removeEventListener('scroll', this.scrollToTop)
	   },
	 // 销毁监听
	 		beforeDestroy() {
	 		  window.removeEventListener('resize', this.handleResize);
	 		},
	 methods: {
		goCourse(e){
		this.$router.push({
				path: '/Courselist',
				name: '/Courselist',
				query: {
					category_id:e
				}
			});
		},	
		getcolCate(){
				var data={
					organ_id:13
				}
				getcolCate(data).then(res => {
				if (res.data.code == 200) {
					this.colCate=res.data.data.left
					console.log("基地",this.colCate)
				}
				// loading.close();
			})
		},
		gocamp(e){
		// console.log(e)
		this.$router.push({
		  path: "/Camplist",
		  name: "/Camplist",
		  query: {
		    tags_id: e,
		  }
		});
	},
		 gotopsearch(){
		 		  this.$router.push({
		 		    path: this.top_search_url,
		 		    name: this.top_search_url,
		 		    query: {
		 		      stitle: this.stitle,
		 		    }
		 		  }); 
		 },
		 manageurl(e){
		 		  console.log('Site',e)
		 		  if(e!='/'){
		 			   window.open(e) 
		 		  }
		 		this.manage_url='/'
		 		  // window.location.href = e;
		 		  
		 },
	 		  vanlinkgo(e){
	 		  		  console.log(e)
	 		  		  this.$router.push({
	 		  		    path: e.link,
	 		  		    name: e.link,
	 		  		    query: {
	 		  		    }
	 		  		  }); 
	 		  },
	 		  vannavmenushow(){
	 		  		this.vannavshow=false  
	 		  },
	 		  handleResize() {
	 		  		   this.top_bannerWidth = 0;
	 		    this.screenWidth = window.innerWidth;
	 		  		this.top_bannerWidth=window.innerWidth/3.42
	 		  		console.log('screenWidth',this.screenWidth,this.top_bannerWidth)
	 		    this.screenHeight = window.innerHeight;
	 		  },
		 getbottomnav(){
		 		  var data={
		 			  page_index:1,
		 			  page_size:15,
					   flag:99
		 		  }
		 		getbottomnav(data).then(res=>{
		 			this.bottomnav=res.data.data.list
		 		})  
		 },
		 gobottomnav(type,link){
		 		  if(type==1){
		 			  this.$router.push({
		 			  	path:link
		 			  });
		 		  }else if(type==2){
			  window.location.href = link;
		  }
		 },
		 logout(){
		 			  var that=this
		 			  this.$confirm('是否确认退出登录?', '提示', {
		 			  					confirmButtonText: '确定',
		 			  					cancelButtonText: '取消',
		 			  					type: 'warning'
		 			  }).then(() => {
		 						this.$alert("已退出登录", '', {
		 							confirmButtonText: '确认',
		 							callback: action => {
		 								localStorage.setItem('token', '')
		 								localStorage.setItem('refreshToken', '')
		 								 that.$router.go(0)
		 							}
		 						  });
		 			  }).catch(() => {
		 			  		 
		 			  });
		 },
		 showofficialQRCode(){
		  		 this.showofficialQR=true
		  },
		  hideofficialQRCode(){//隐藏二维码
		      this.showofficialQR = false
		  },
		  showserviceQRCode(){
		 			  this.showserviceQR=true
		 },
		 hideserviceQRCode(){//隐藏二维码
		     this.showserviceQR = false
		 },
		 showQRCode(){//显示二维码
		         this.showQR = true
		     },
		     hideQRCode(){//隐藏二维码
		         this.showQR = false
		     },
		     scrollToTop () {
		         let scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
		         this.scrolltop = scrollTop
		         if (parseInt(this.scrolltop) > (parseInt(this.heights) / 3)) {
		             this.tops = true
		         } else {
		             this.tops = false
		         }
		     },
		     gotop () {
		         let timer = setInterval(() => {
		             document.documentElement.scrollTop = document.body.scrollTop = this.scrolltop - 90
		             if (this.scrolltop === 0) {
		                 clearInterval(timer)
		             }
		         }, 15)
		     },
		 showphonebox(){
		 		this.phoneboxshow=true  
		 },
		 closephonebox(){
		 		this.phoneboxshow=false  
		 },
		 goregister(e){
		 			  this.$router.push({
		 			    path: "/register",
		 			    name: "/register",
		 			  		  query: {
		 			  		  }
		 			  });
		 },
		 gomap(e) {
		   this.$router.push({
			path: "/Campmap",
			name: "/Campmap",
			query: {
			  latitude:e.latitude,
			  longitude:e.longitude,
			}
		   });
		 },
		 gohome(e) {
		   this.$router.push({
		     path: "/Home1",
		     name: "/Home1",
		 			  query: {
		 			  }
		   });
		 },
	 		  getpcset(){
				var data={
				flag:99
			}
	 		  		getPc(data).then(res=>{
	 		  			this.pcsetdata=res.data.data
	 		  		})  
	 		  },
		  camptypetab(val){
			  this.category_id=val
			  this.getlist()
		  },
		  periodtab(val){
			  this.period=val
			  this.getlist()
		  },
		  pagechange(val){
			this.page_index=val
			this.getlist()
		  },
		  getDetails(){
			var data={
				// type:this.camptype,
				uuid:this.uuid,
				organ_id:13
			}  
			getproductlist(data).then(res=>{
				console.log(res.data)
				this.coursedata=res.data.data
				const loading = this.$loading({
				         lock: true,
				         text: 'Loading',
				         spinner: 'el-icon-loading',
				         background: 'rgba(0, 0, 0, 0.7)'
				       });
				loading.close();
				// this.total=res.data.data.total
				// this.quicklist=res.data.data.list
			}).catch(error => {
				console.error(error);
			});
		  },
		  handleClick(e){
				console.log(e,this.category_id)
				 this._getNewslist()
		  },
		  onitemopen(index){
			  this.newsiconon=index
		  },
		  gettypes(){
			var data={}
			getPac(data).then(res=>{
				console.log(res.data)
				this.categorytypes=res.data.data.cat
				this.periodtypes=res.data.data.res
				// this.category_id=res.data.data.cat[0].id
				// this.getlist()
			}).catch(error => {
			  console.error(error);
			});
		  },
		  /*
		   * 查看详情
		   * */
		  gocampdetail(e) {
		    this.$router.push({
		      path: "/CampDetails",
		      name: "CampDetails",
		      query: {
		        id: e
		      }
		    });
		  },

	  }
	};
</script>

<style scoped>
::v-deep.el-tabs__item.is-active{
	color: #FE7C2B !important;
}
.pro_msg{
	text-align: start;
	padding: 20px;
	line-height: 30px;
	white-space: pre-line;
	padding-top: 0px;
}
.top{
	background-image: url(../../../static/img/topbanner.png);
	position: relative;
	background-size: cover;
	width: 100%;
	height: 140px;
}
.bgimg{
	
	padding-top: 20px;
	background-image: url(../../../static/img/图1遮罩.jpg);
	background-repeat: no-repeat;
	background-attachment: fixed;
	
}
.search{
	width: 250px;
	position: absolute;
	right: 120px;
	display: flex;
	top: 70px;
}
.nav{
	position: absolute;
	color: #ffffff;
	display: flex;
	right: 60px;
	top: 50px;

}
.nav_box{
	margin-right: 50px;
}
.nav_box:hover{
	cursor: pointer;
}
	.coursemain_richitem{
		padding-bottom: 50px;
	}
	.coursemain{
		padding: 5px 20px;
		font-size: 16px;
		line-height: 24px;
		text-indent: 2rem;
		text-align: left;
	}
	.el-tag--dark{
		border: 0px;
		margin:0px 2px;
	}
	.camp_item{
		padding: 20px;
		margin-top: 20px;
		/* width: 1060px; */
		background: #ffffff;
		
	}
	.campmsg_box{
		display: flex;
		/* justify-content: space-between; */
			align-items: stretch;
	}
	.camp_img{
		width: 337.5px;
		height: 161px;
		margin-left: 30px;
		margin-right: 50px;
	}
	.camp_img img{
		width: 100%;
		height: 100%;
	
	}
	.camp_msg{
		/* width: 100%; */
		display: flex;
		flex-direction: column;
		justify-content: space-between;
	
	}
	.camp_title{
		    font-size: 20px;
		    font-weight: 600;
		    text-align: left;
		    padding: 20px 0px;
	}
	.camp_address{
		color: #FE7C2B;
		padding-bottom: 20px;
		    font-size: 16px;
			 text-align: left;
	}
	.camp_phone{
		padding-bottom: 20px;
		color: #66b1ff;
		 text-align: left;
	}
	.moduletitle{
		display: flex;
		align-items: center;
		font-size: 20px;
		margin-bottom: 10px;
	}
	.rich_title{
		padding: 20px;
		padding-bottom: 0px;
		display: flex;
		justify-content: flex-start;
		align-items: center;
		font-size: 18px;
		font-weight: 600;
	}
	.richblock{
		width: 6px;
		height: 30px;
		margin-right: 20px;
		display: block;
		background: #FE7C2B;
	}
	.coursemain_box{
		/* padding: 20px; */
		background: #ffffff;
		margin-top: 20px;
	}
	@media only screen and (max-width: 768px){
	::v-deep .el-tabs--card>.el-tabs__header .el-tabs__item{
	     padding-right: 20px !important;
	 }
	 }
	 .xc_top{
  display: flex;
  align-items: center;
  padding-bottom: 10px;
  border-bottom: 1px solid #d9d9d9;
}
.detail_box{
  padding: 20px;
  box-sizing: border-box;
  background-color: #fff;
}
.xc_time{
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  padding: 5px;
  border-right: 1px solid #d9d9d9;
  padding-right: 7px;
  font-weight: bold;
  font-family: "楷体","楷体_GB2312";
  font-size:20px;
  letter-spacing: 2px;
  
}
.title_left{
    width: 5px;
    margin-right: 10px;
    height: 20px;
 
    border-radius: 30px;
  }
.xc_title{
  padding-left: 10px;
 
}
.xc_contain{
  display: flex;
  margin-top: 10px;
  font-weight: bold;
  font-size: 15px;
}
.xc_icon{
  width: 25px;
  height: 25px;
  /* border: 1px solid red; */
  margin-right: 18px;
}
.xc_col{
  display: flex;
  margin-right: 0px;
  align-items: center;
  margin-right: 10px;
  /* margin-top: 3px; */

}

.xz_title_box{
  display: flex;
  justify-content: space-between;
  font-weight: bold;
  padding-bottom: 10px;
  border-bottom: 1px solid #eceaea;
  margin-top: 10px;
  margin-bottom: 10px;
}
</style>